import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import I18n from '../../lib/i18n';
import {
  SimpleFormString,
} from '../../lib/components/SimpleForm';

export default class IpRestrictionRow extends React.PureComponent {
  static propTypes = {
    index: PropTypes.number.isRequired,
    ipRestriction: PropTypes.instanceOf(Map),
    removeForm: PropTypes.func.isRequired,
    updateForm: PropTypes.func.isRequired,
  }

  handleClick() {
    const { index, removeForm } = this.props;
    removeForm(index);
  }

  handleChange(e) {
    const { index, updateForm } = this.props;
    // ip_restriction__ip_addr から ip_addr を取り出す
    const column = e.target.id.split('__')[1];
    const value = e.target.value;

    updateForm(index, column, value);
  }

  renderDestroyButton() {
    const { index } = this.props;
    if (index === 0) {
      return (
        <div
          className="btn btn-danger"
          style={{ marginTop: '30px' }}
          onClick={() => this.handleClick()}
        >
          -
        </div>
      );
    }

    return (
      <div
        className="btn btn-danger"
        onClick={() => this.handleClick()}
      >
        -
      </div>
    );
  }

  render() {
    const { index, ipRestriction } = this.props;

    return (
      <div className="row">
        <div className="col-md-1">
          { this.renderDestroyButton() }
        </div>

        <div className="col-md-5">
          <SimpleFormString
            name="ip_restriction[ip_restrictions][][ip_addr]"
            required
            label={index === 0 ? I18n.t('activerecord.attributes.ip_restriction.ip_addr') : ''}
            value={ipRestriction.get('ip_addr') || ''}
            placeholder="127.0.0.1/32"
            errorMessage={ipRestriction.getIn(['errors', 'ip_addr'])}
            onChange={(e) => this.handleChange(e)}
          />
        </div>

        <div className="col-md-6">
          <SimpleFormString
            name="ip_restriction[ip_restrictions][][note]"
            label={index === 0 ? I18n.t('activerecord.attributes.ip_restriction.note') : ''}
            value={ipRestriction.get('note') || ''}
            placeholder={I18n.t('activerecord.attributes.ip_restriction.note')}
            errorMessage={ipRestriction.getIn(['errors', 'note'])}
            onChange={(e) => this.handleChange(e)}
          />
        </div>
      </div>
    );
  }
}
